
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import styles from "./generalDialog.module.scss";

const GeneralDialog = (props: GeneralDialogProps) => {
  const {children, open, onCancel, onSave, onClose, title, fullwidth, cancelText, saveText} = props;

  return (
    <Dialog open={open} onClose={onClose} fullWidth={fullwidth}>
      <div className={styles.content}>
        <DialogTitle sx={{fontWeight: 700, fontSize: "24px", padding: "40px"}}>{title}</DialogTitle>
        <DialogContent sx={{padding: "0 40px 62px"}}>
          {children}
        </DialogContent>
        <DialogActions sx={{padding: "0 40px 24px", justifyContent: "center", gap: "16px"}}>
          <Button variant="outlined" color="primary" onClick={onCancel}>{cancelText}</Button>
          <Button variant="contained" color="primary" onClick={onSave}>{saveText}</Button>
        </DialogActions>
      </div>
    </Dialog>  
  )
}

export default GeneralDialog;

export type GeneralDialogProps = {
  children: any;
  open: boolean;
  onClose: () => void;
  onSave: () => void;
  onCancel: () => void;
  cancelText: string;
  saveText: string;
  title: string;
  fullwidth?: boolean;
}